import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BreadService } from '../bread.service';
import { ApiService } from '../api.service';
import { Setting } from '@app/core/models/setting.models';
import { BaseCrudService } from '../bread-crud.service';

@Injectable({ providedIn: 'root' })
export class SettingService extends BaseCrudService<Setting> {
  protected model = 'settings';
  private api = inject(ApiService);

  /** Cache des settings (rempli au chargement layout / checkInstallation). */
  settings: Setting[] = [];

  constructor(bread: BreadService) {
    super(bread);
  }

  setSettings(settings: Setting[]): void {
    this.settings = settings ?? [];
  }

  getSettingByName(name: string): Setting | undefined {
    return this.settings.find((s) => s.name === name);
  }

  setSettingValue(name: string, value: string): void {
    const idx = this.settings.findIndex((s) => s.name === name);
    if (idx >= 0) {
      this.settings[idx] = { ...this.settings[idx], value };
    } else {
      this.settings.push({ name, value } as Setting);
    }
  }

  /**
   * Module / feature activé dans les paramètres shop.
   * Si le setting n’existe pas encore en base → `true` (comportement historique).
   */
  isModuleEnabled(settingName: string): boolean {
    const row = this.getSettingByName(settingName);
    if (!row) {
      return true;
    }
    return SettingService.isTruthySettingValue(row.value);
  }

  /** Valeurs considérées comme « oui » pour un switch / flag API (1, true, "1", "true", …). */
  static isTruthySettingValue(value: unknown): boolean {
    if (value === true || value === 1) {
      return true;
    }
    if (value === false || value === 0) {
      return false;
    }
    if (value == null || value === '') {
      return false;
    }
    const s = String(value).trim().toLowerCase();
    return s === '1' || s === 'true' || s === 'yes' || s === 'on';
  }
}
